export const table = {
    primaryData: [
        { title: "ID", value: "id", type: "configue" },
        { title: "Name", value: "name", type: "configue" },
        { title: "Description", value: "description", type: "configue" },
        { title: "Is Teaching", value: "isTeaching", type: "configue" },
        { title: "Is Language", value: "isLanguage", type: "configue" },
    ],
    secondaryData: [
         { title: "Created At", value: "createdAt", type: "configue" },
        { title: "Updated At", value: "updatedAt", type: "configue", name:"updatedAt" },
        { title: "Created By", value: "createdByName", type: "configue" },
        { title: "Updated By", value: "updatedByName", type: "configue", name:"updatedByName" },
    ],
    
};
